import React from 'react';
import { ArrowRight, Lightbulb } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <Lightbulb size={20} />
            <span>Profesionalna edukacija i savjetovanje</span>
          </div>
          
          <h1 className="hero-title">
            Ostvarite svoj <span className="highlight">potencijal</span>
          </h1>
          
          <p className="hero-description">
            Stručna poduka iz frontend razvoja, matematike, fizike, MS Excela i profesionalnog savjetovanja za karijeru. Individualni pristup koji donosi rezultate.
          </p>
          
          <div className="hero-buttons">
          <button className="btn-secondary" onClick={() => {
              const element = document.getElementById('services');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}>
              Pregledajte usluge
            </button>
            <button className="btn-primary" onClick={scrollToContact}>
              Zatražite uslugu
              <ArrowRight size={20} />
            </button>
        
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">10+</div>
              <div className="stat-label">godina iskustva</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-number">100+</div>
              <div className="stat-label">zadovoljnih polaznika</div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-number">5</div>
              <div className="stat-label">iz zalaganja</div>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="visual-card">
            <img 
              src="/images/umguehcc_LookApp_Logo_Transparent.png" 
              alt="LookApp Logo" 
              className="hero-logo"
            />
          </div>
          <div className="floating-element element-1"></div>
          <div className="floating-element element-2"></div>
          <div className="floating-element element-3"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
